'use strict';

import {isNaN,currency,fixed,percent} from '../../lang';
import template from './template.html';
import slider from '../slider';

const PROPERTY = 'calculator';

export default {
  template,
  replace: false,
  components: {
    'vue-slider': slider
  },
  props: {
    [PROPERTY]: {
      type: Object,
      required: true
    }
  },
  mounted: function(){
  },
  computed: {
    constants: function() {
      return this[PROPERTY].constants;
    },
    dictionaries: function () {
      return this[PROPERTY].dictionaries;
    },
    state: function () {
      return this[PROPERTY].state;
    },
    relations: function () {
      return this[PROPERTY].relations;
    },
    hashes: function () {
      return this[PROPERTY].hashes;
    },
    keyOfRate: function () {
      return this[PROPERTY].keyOfRate;
    },
    layers: function () {
      return this[PROPERTY].layers;
    },
    scrolling: function () {
      return this[PROPERTY].scrolling;
    },
    filteredAndOrderedBanks() {
      let list = this.dictionaries.banks.slice();
      list = list.filter(this.filterNaNMonthPayment);
      list.sort(this.compareByMonthPayment);
      return list;
    }
  },
  methods: {
    currency,
    fixed,
    percent,
    calcMonthPayment: function (bankId) {
      return this[PROPERTY].calcMonthPayment(bankId);
    },
    filterNaNMonthPayment(bank) {
      let ref = this[PROPERTY];
      let val1 = ref.calcMonthPayment(bank.id);
      return !isNaN(val1);
    },
    compareByMonthPayment(bank1, bank2) {
      let ref = this[PROPERTY];
      let val1 = ref.calcMonthPayment(bank1.id);
      let val2 = ref.calcMonthPayment(bank2.id);
      return val1 - val2;
    }
  }
};


// WEBPACK FOOTER //
// ./src/js/components/calculator/index.js